import { mapState, mapActions } from 'vuex';
import searchMixin from '@/mixins/search';

const SEARCH_BAR_VISIBLE_FOCUS_TIMEOUT = 500;

export default {
  mixins: [
    searchMixin,
  ],
  data() {
    return {
      searchQuery: '',
      searchFor: '',
      searchTotal: null,
    };
  },
  computed: {
    ...mapState('search', ['searchBarVisible']),
    showSummary() {
      return this.searchTotal === 0;
    },
    summaryClassModifiers() {
      return {
        'search-bar__summary': true,
        'search-bar__summary--no-results': !this.searchTotal,
      };
    },
  },
  watch: {
    $route() {
      if (this.searchBarVisible) {
        this.onClose();
      }
    },
    searchBarVisible(value) {
      if (value) {
        setTimeout(() => {
          this.$refs.searchInput.focus();
        }, SEARCH_BAR_VISIBLE_FOCUS_TIMEOUT);
      }
    },
  },
  methods: {
    ...mapActions('search', ['toggleSearchBar']),
    onSearchResults(data) {
      if (data.totalMarkets > 0) { // close when there are results
        this.onClose();
      }
      this.searchTotal = data.totalMarkets;
    },
    onClose() {
      this.toggleSearchBar();
      this.searchFor = '';
      this.searchQuery = '';
      this.searchTotal = null;
    },
    onSubmit() {
      this.searchTotal = null;
      if (this.searchQuery === '') return;
      this.searchFor = this.searchQuery;
      this.doSearch(this.searchQuery);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-header/search-bar/search-bar.js